import { Permission } from '@common/permissions';
import React, { useEffect } from 'react';
import { usePermissions } from 'src/apps/invest/common/hooks/usePermissions';
import { useSession } from 'src/apps/invest/common/hooks/useSession';
import { ROUTES } from 'src/apps/invest/config';
import { BankAccountsPage } from '../views/BankAccountsPage';

const sessionRedirect = ROUTES.bankAccounts;
const permissions: Permission[] = ['ACCREDITED_INVESTOR', 'UNACCREDITED_INVESTOR'];

export const BankAccountsController: React.FC = () => {
  const { checkAuthenticated } = useSession();
  const { checkPermissions } = usePermissions();

  async function init() {
    if (!(await checkAuthenticated(sessionRedirect))) return;
    if (!(await checkPermissions(permissions))) return;
  }

  useEffect(() => {
    init();
  }, []);

  return <BankAccountsPage />;
};
